
import is from "is_js";
import { useAppContext } from "Main";
import React, { lazy, Suspense, useEffect } from "react";
import { Spinner } from "react-bootstrap";

import { BrowserRouter as Router } from "react-router-dom";

// Lazy load routes
const FalconRoutes = lazy(() => import("routes"));

// Lazy load ToastContainer to reduce main.js
const ToastContainerLazy = lazy(() =>
  import("./ToastContainerWrapper")
);


const App = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const {
    config: { navbarPosition },
  } = useAppContext();

  useEffect(() => {
    // ✅ Suppress ResizeObserver error globally
    const handler = (e) => {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener("error", handler);

    return () => {
      window.removeEventListener("error", handler);
    };
  }, []);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
    if (is.safari()) {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === "double-top") {
      HTMLClassList.add("double-top-nav-layout");
    }
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, [navbarPosition]);

  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner variant="primary" animation="border" />
        </div>
      }
    >

      <Router>
        <FalconRoutes />
        {/* <SettingsToggle />
      <SettingsPanel /> */}
        {/* <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      /> */}
        <ToastContainerLazy />
      </Router>
    </Suspense >
  );
};

export default App;
